import { createFileRoute, redirect } from '@tanstack/react-router';

// The consent lifecycle is a tab of the receptora; the old address opens it there.
export const Route = createFileRoute('/consentimentos/')({
  beforeLoad: () => redirect({ to: '/receptora', search: { aba: 'consentimentos' } }),
  component: (): JSX.Element => <></>,
});
